"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.observableMethod = exports.observableController = void 0;
var observableController_1 = require("./observableController");
Object.defineProperty(exports, "observableController", { enumerable: true, get: function () { return observableController_1.observableController; } });
var observableMethod_1 = require("./observableMethod");
Object.defineProperty(exports, "observableMethod", { enumerable: true, get: function () { return observableMethod_1.observableMethod; } });
//# sourceMappingURL=index.js.map